import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { headlineFigure } from "@/lib/promotions";
import { OfferCountdown } from "@/components/OfferCountdown";

export const LastCallRibbon = () => {
  const navigate = useNavigate();
  const [promos, setPromos] = useState([]);
  useEffect(() => { api.get("/promotions/last-call").then(({ data }) => setPromos(data)).catch(() => {}); }, []);
  if (!promos.length) return null;
  return (
    <div data-testid="last-call-ribbon" className="mt-6 overflow-hidden rounded-xl border border-red-200 dark:border-red-900/60 bg-white dark:bg-slate-900 shadow-sm">
      <div className="flex items-center gap-2 bg-red-600 px-4 py-2 text-white">
        <Flame className="h-4 w-4 animate-pulse" strokeWidth={2.5} />
        <span className="font-mono text-xs font-bold uppercase tracking-[0.2em]">Last 48 hours</span>
        <span className="ml-auto hidden text-xs font-semibold opacity-90 sm:inline">Specials matching your saved searches are about to expire</span>
      </div>
      <div className="divide-y divide-slate-100 dark:divide-slate-800">
        {promos.map((p) => (
          <button key={p.id} data-testid={`last-call-item-${p.id}`} onClick={() => navigate("/specials")}
            className="group flex w-full flex-wrap items-center gap-x-4 gap-y-2 px-4 py-3 text-left transition-colors hover:bg-red-50/60 dark:hover:bg-red-950/20">
            <span className="text-[11px] font-bold uppercase tracking-wide text-slate-400 dark:text-slate-500">{p.make}{p.model ? ` ${p.model}` : ""}</span>
            <span className="font-display text-xl font-black leading-none tracking-tight text-red-600 dark:text-red-500">{headlineFigure(p) || p.title}</span>
            {headlineFigure(p) && <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">{p.title}</span>}
            <OfferCountdown promo={p} className="ml-auto" testId={`last-call-countdown-${p.id}`} />
            <ArrowRight className="h-4 w-4 text-slate-300 transition-transform group-hover:translate-x-0.5" />
          </button>
        ))}
      </div>
    </div>
  );
};
